function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fb6415c1-f574-4dab-bb02-7ceb0a7d0718",
  x1: 596,
  y1: 757.78,
  x2: 596,
  y2: 598.14,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "discount");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 840.37,
  cy: 625.03,
  rx: 22.09,
  ry: 28.91,
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M886.35,619.49A34.83,34.83,0,0,0,891,601.82c0-16-9.89-28.91-22.09-28.91s-22.08,12.94-22.08,28.91a34.83,34.83,0,0,0,4.61,17.67,36.15,36.15,0,0,0,0,35.33,36.17,36.17,0,0,0,0,35.34,34.83,34.83,0,0,0-4.61,17.67c0,16,9.89,28.91,22.08,28.91S891,723.8,891,707.83a34.83,34.83,0,0,0-4.61-17.67,36.17,36.17,0,0,0,0-35.34,36.15,36.15,0,0,0,0-35.33Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 840.37,
  cy: 448.35,
  rx: 22.09,
  ry: 28.91,
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 840.37,
  cy: 413.01,
  rx: 22.09,
  ry: 28.91,
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M951.55,289.33a106.47,106.47,0,0,0,8.22-12.11l-58-9.53,62.77.47a106,106,0,0,0,2-83.82L882.32,228,960,170.94A105.8,105.8,0,1,0,785.25,289.33a106,106,0,0,0-12.06,19.29l75.33,39.14-80.32-27a105.8,105.8,0,0,0,17,99.34,105.79,105.79,0,1,0,166.3,0,105.79,105.79,0,0,0,0-130.81Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M762.61,354.74a105.31,105.31,0,0,0,22.64,65.4,105.79,105.79,0,1,0,166.3,0C965.73,402.14,762.61,342.86,762.61,354.74Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 220.81,
  cy: 605.42,
  rx: 13.44,
  ry: 17.6,
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260,648.27a21.23,21.23,0,0,0,2.81-10.76c0-9.72-6-17.6-13.45-17.6s-13.44,7.88-13.44,17.6a21.23,21.23,0,0,0,2.8,10.76,22.06,22.06,0,0,0,0,21.51,22.06,22.06,0,0,0,0,21.51,21.16,21.16,0,0,0-2.8,10.75c0,9.73,6,17.61,13.44,17.61s13.45-7.88,13.45-17.61A21.16,21.16,0,0,0,260,691.29a22,22,0,0,0,0-21.51,22,22,0,0,0,0-21.51Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 220.81,
  cy: 497.86,
  rx: 13.44,
  ry: 17.6,
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 220.81,
  cy: 476.35,
  rx: 13.44,
  ry: 17.6,
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M199,447.27a64.1,64.1,0,0,1-5-7.37l35.33-5.8-38.21.29a64.57,64.57,0,0,1-1.23-51L241.12,410,193.85,375.2a64.4,64.4,0,1,1,106.37,72.07A64.33,64.33,0,0,1,307.56,459L261.7,482.84l48.9-16.41a64.44,64.44,0,0,1-10.38,60.48,64.4,64.4,0,1,1-101.24,0,64.42,64.42,0,0,1,0-79.64Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M314,487.09a64.15,64.15,0,0,1-13.78,39.82,64.4,64.4,0,1,1-101.24,0C190.35,516,314,479.86,314,487.09Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 523.81,
  cy: 614.79,
  rx: 17.99,
  ry: 23.55,
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M566.55,632.17a28.41,28.41,0,0,0,3.75-14.4c0-13-8-23.55-18-23.55s-18,10.55-18,23.55a28.32,28.32,0,0,0,3.76,14.4,29.44,29.44,0,0,0,0,28.79,29.42,29.42,0,0,0,0,28.78,28.32,28.32,0,0,0-3.76,14.4c0,13,8.06,23.55,18,23.55s18-10.55,18-23.55a28.41,28.41,0,0,0-3.75-14.4,29.48,29.48,0,0,0,0-28.78,29.5,29.5,0,0,0,0-28.79Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 523.81,
  cy: 470.85,
  rx: 17.99,
  ry: 23.55,
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 523.81,
  cy: 442.06,
  rx: 17.99,
  ry: 23.55,
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485,363.2a85.91,85.91,0,0,1-6.7-9.86l47.27-7.76-51.12.38a86.35,86.35,0,0,1-1.65-68.29l68.6,35.58-63.27-46.5A86.19,86.19,0,1,1,620.44,363.2a86.33,86.33,0,0,1,9.82,15.72L568.9,410.8l65.43-22a86.22,86.22,0,0,1-13.89,80.93,86.18,86.18,0,1,1-135.48,0,86.21,86.21,0,0,1,0-106.57Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M638.88,416.49a85.81,85.81,0,0,1-18.44,53.28,86.18,86.18,0,1,1-135.48,0C473.41,455.11,638.88,406.81,638.88,416.49Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1171.5,754.36c0,6.87-50.22,13.15-133.25,18-15.1.87-31.28,1.7-48.44,2.48q-22.24,1-46.62,1.89-23.62.84-49.05,1.56c-53.54,1.53-112.73,2.63-175.61,3.18q-22.89.21-46.39.32-24.48.11-49.52.1c-303.14,0-548.87-12.31-548.87-27.5s245.73-27.5,548.87-27.5c130.51,0,250.36,2.29,344.56,6.09l10.3.42h.06C1096.2,738.43,1171.5,746,1171.5,754.36Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1171.5,754.36c0,6.87-50.22,13.15-133.25,18-15.1.87-31.28,1.7-48.44,2.48q-22.24,1-46.62,1.89-23.62.84-49.05,1.56c-53.54,1.53-112.73,2.63-175.61,3.18q-22.89.21-46.39.32-24.48.11-49.52.1c-303.14,0-548.87-12.31-548.87-27.5s245.73-27.5,548.87-27.5c130.51,0,250.36,2.29,344.56,6.09l10.3.42h.06C1096.2,738.43,1171.5,746,1171.5,754.36Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.15
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1126.25,749.52c0,5.74-50.22,11-133.25,15-15.09.73-31.28,1.42-48.43,2.07q-22.25.84-46.62,1.58-23.62.7-49.05,1.31c-53.55,1.28-112.74,2.2-175.62,2.66q-22.87.17-46.39.26-24.48.09-49.51.09c-303.14,0-548.88-10.29-548.88-23s245.74-23,548.88-23c130.5,0,250.35,1.91,344.55,5.09l10.3.35h.07C1051,736.2,1126.25,742.49,1126.25,749.52Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#3f3d56"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M170.26,540.59,156.48,498.4l330-3.61L500,536.56Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#3f3d56"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M170.26,540.59,156.48,498.4l330-3.61L500,536.56Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.15
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M148.26,540.59,134.48,498.4l330-3.61L478,536.56Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#3f3d56"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M711.61,475.76q-51.18,0-80.67-40.63t-29.49-98.44q0-58.2,28.52-98.24t80.46-40q55.08,0,83,42.19t27.93,97.66q0,55.07-28.9,96.28T711.61,475.76Zm1-30.47q33.67,0,50.33-29.35t16.66-74q0-49.7-17.05-81.39t-52.3-31.7q-67,0-67,106.44Q643.25,445.3,712.59,445.29Zm11.24,291.79H674.5l323.08-533.2H1046Zm285.82,5.47q-51.95,0-81-41T899.5,603.1q0-57.81,28.32-97.85t80.66-40q54.69,0,82.42,42.19t27.74,97.65q0,54.71-28.71,96.1T1009.65,742.55Zm.58-31.25q33.51,0,50.06-28.85t16.55-73.7q0-48-16.75-80.51t-52.19-32.56q-67.39,0-67.39,106.44Q940.51,711.31,1010.23,711.3Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#3f3d56"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M711.61,475.76q-51.18,0-80.67-40.63t-29.49-98.44q0-58.2,28.52-98.24t80.46-40q55.08,0,83,42.19t27.93,97.66q0,55.07-28.9,96.28T711.61,475.76Zm1-30.47q33.67,0,50.33-29.35t16.66-74q0-49.7-17.05-81.39t-52.3-31.7q-67,0-67,106.44Q643.25,445.3,712.59,445.29Zm11.24,291.79H674.5l323.08-533.2H1046Zm285.82,5.47q-51.95,0-81-41T899.5,603.1q0-57.81,28.32-97.85t80.66-40q54.69,0,82.42,42.19t27.74,97.65q0,54.71-28.71,96.1T1009.65,742.55Zm.58-31.25q33.51,0,50.06-28.85t16.55-73.7q0-48-16.75-80.51t-52.19-32.56q-67.39,0-67.39,106.44Q940.51,711.31,1010.23,711.3Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#3f3d56"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M711.61,475.76q-51.18,0-80.67-40.63t-29.49-98.44q0-58.2,28.52-98.24t80.46-40q55.08,0,83,42.19t27.93,97.66q0,55.07-28.9,96.28T711.61,475.76Zm1-30.47q33.67,0,50.33-29.35t16.66-74q0-49.7-17.05-81.39t-52.3-31.7q-67,0-67,106.44Q643.25,445.3,712.59,445.29Zm11.24,291.79H674.5l323.08-533.2H1046Zm285.82,5.47q-51.95,0-81-41T899.5,603.1q0-57.81,28.32-97.85t80.66-40q54.69,0,82.42,42.19t27.74,97.65q0,54.71-28.71,96.1T1009.65,742.55Zm.58-31.25q33.51,0,50.06-28.85t16.55-73.7q0-48-16.75-80.51t-52.19-32.56q-67.39,0-67.39,106.44Q940.51,711.31,1010.23,711.3Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.15
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M680.61,475.76q-51.18,0-80.67-40.63t-29.49-98.44q0-58.2,28.52-98.24t80.46-40q55.08,0,83,42.19t27.93,97.66q0,55.07-28.9,96.28T680.61,475.76Zm1-30.47q33.67,0,50.33-29.35t16.66-74q0-49.7-17.05-81.39t-52.3-31.7q-67,0-67,106.44Q612.25,445.3,681.59,445.29Zm11.24,291.79H643.5l323.08-533.2H1015Zm285.82,5.47q-51.95,0-81-41T868.5,603.1q0-57.81,28.32-97.85t80.66-40q54.69,0,82.42,42.19t27.74,97.65q0,54.71-28.71,96.1T978.65,742.55Zm.58-31.25q33.51,0,50.06-28.85t16.55-73.7q0-48-16.75-80.51T976.9,495.68q-67.39,0-67.39,106.44Q909.51,711.31,979.23,711.3Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#3f3d56"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M788.57,750.46c4.12-7.64-.56-17-5.94-23.82s-11.94-13.9-11.8-22.59c.2-12.47,13.44-19.84,24-26.46a117.08,117.08,0,0,0,21.58-17.34,31.68,31.68,0,0,0,6.63-8.88c2.19-4.88,2.12-10.43,2-15.77q-.69-26.72-2.64-53.36",
  transform: "translate(-28.5 -118.14)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 4
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M842.52,581.26a19.43,19.43,0,0,0-9.71-15.94l-4.36,8.62.13-10.44a19.69,19.69,0,0,0-6.41-.77,19.46,19.46,0,1,0,20.35,18.53Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M807.82,713a19.45,19.45,0,1,1,.94-15.67l-12.16,9.89L810,704.1A19.4,19.4,0,0,1,807.82,713Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M798.21,675.19a19.46,19.46,0,0,1-20.35-18.53,19.24,19.24,0,0,1,1.68-8.87A19.49,19.49,0,0,1,792,637l-.11,8,4.41-8.72h0a19.46,19.46,0,1,1,1.82,38.88Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M845.45,643.76a19.47,19.47,0,1,1-1.82-38.89,19.28,19.28,0,0,1,10.42,2.47l-3.44,9.42,7.08-6.79A19.4,19.4,0,0,1,864,623.4a19,19,0,0,1-.5,5.36A19.47,19.47,0,0,1,845.45,643.76Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M839.9,586.45c-4.49.49-8.85,1.89-13.36,2.17s-9.46-.8-12.31-4.31c-1.54-1.88-2.3-4.27-3.6-6.33a13.79,13.79,0,0,0-4.9-4.61,19.46,19.46,0,1,0,36.38,12.91C841.37,586.32,840.64,586.37,839.9,586.45Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M845.45,643.76A19.48,19.48,0,0,1,826.94,616a14.58,14.58,0,0,1,3.91,3.92c1.39,2.09,2.23,4.51,3.86,6.43,3,3.57,8.21,4.73,12.9,4.52s9.23-1.55,13.91-2c.65-.06,1.31-.1,2-.12A19.47,19.47,0,0,1,845.45,643.76Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M798.21,675.19a19.46,19.46,0,0,1-20.35-18.53,19.24,19.24,0,0,1,1.68-8.87,15.66,15.66,0,0,1,4.11,4c1.51,2.13,2.46,4.59,4.23,6.56,3.28,3.65,8.8,4.94,13.77,4.82s9.46-1.28,14.25-1.65A19.47,19.47,0,0,1,798.21,675.19Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M807.82,713a19.46,19.46,0,0,1-35.48-15.88,19.6,19.6,0,0,1,4.27,3.81c1.85,2.26,3.07,4.82,5.21,6.92,4,3.9,10.4,5.51,16.12,5.66A82.85,82.85,0,0,0,807.82,713Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M1089.57,749.46c4.12-7.64-.56-17-5.94-23.82s-11.94-13.9-11.8-22.59c.2-12.47,13.44-19.84,24-26.46a117.08,117.08,0,0,0,21.58-17.34,31.68,31.68,0,0,0,6.63-8.88c2.19-4.88,2.12-10.43,2-15.77q-.69-26.72-2.64-53.36",
  transform: "translate(-28.5 -118.14)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 4
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M1143.52,580.26a19.43,19.43,0,0,0-9.71-15.94l-4.36,8.62.13-10.44a19.69,19.69,0,0,0-6.41-.77,19.46,19.46,0,1,0,20.35,18.53Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M1108.82,712a19.45,19.45,0,1,1,.94-15.67l-12.16,9.89L1111,703.1A19.4,19.4,0,0,1,1108.82,712Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M1099.21,674.19a19.46,19.46,0,0,1-20.35-18.53,19.24,19.24,0,0,1,1.68-8.87A19.49,19.49,0,0,1,1093,636l-.11,8,4.41-8.72h.05a19.46,19.46,0,1,1,1.82,38.88Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M1146.45,642.76a19.47,19.47,0,1,1-1.82-38.89,19.28,19.28,0,0,1,10.42,2.47l-3.44,9.42,7.08-6.79A19.4,19.4,0,0,1,1165,622.4a19,19,0,0,1-.5,5.36A19.47,19.47,0,0,1,1146.45,642.76Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M1140.9,585.45c-4.49.49-8.85,1.89-13.36,2.17s-9.46-.8-12.31-4.31c-1.54-1.88-2.3-4.27-3.6-6.33a13.79,13.79,0,0,0-4.9-4.61,19.46,19.46,0,1,0,36.38,12.91C1142.37,585.32,1141.64,585.37,1140.9,585.45Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M1146.45,642.76A19.48,19.48,0,0,1,1127.94,615a14.58,14.58,0,0,1,3.91,3.92c1.39,2.09,2.23,4.51,3.86,6.43,3,3.57,8.21,4.73,12.9,4.52s9.23-1.55,13.91-2c.65-.06,1.31-.1,2-.12A19.47,19.47,0,0,1,1146.45,642.76Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M1099.21,674.19a19.46,19.46,0,0,1-20.35-18.53,19.24,19.24,0,0,1,1.68-8.87,15.66,15.66,0,0,1,4.11,4c1.51,2.13,2.46,4.59,4.23,6.56,3.28,3.65,8.8,4.94,13.77,4.82,4.82-.1,9.46-1.28,14.25-1.65A19.47,19.47,0,0,1,1099.21,674.19Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M1108.82,712a19.46,19.46,0,0,1-35.48-15.88,19.6,19.6,0,0,1,4.27,3.81c1.85,2.26,3.07,4.82,5.21,6.92,4,3.9,10.4,5.51,16.12,5.66A82.85,82.85,0,0,0,1108.82,712Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M138.43,736.46c-4.12-7.64.56-17,5.94-23.82s11.94-13.9,11.8-22.59c-.2-12.47-13.44-19.84-24-26.46a117.08,117.08,0,0,1-21.58-17.34,31.68,31.68,0,0,1-6.63-8.88c-2.19-4.88-2.12-10.43-2-15.77q.69-26.72,2.64-53.36",
  transform: "translate(-28.5 -118.14)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 4
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M84.48,567.26a19.43,19.43,0,0,1,9.71-15.94l4.36,8.62-.13-10.44a19.69,19.69,0,0,1,6.41-.77,19.46,19.46,0,1,1-20.35,18.53Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M119.18,699a19.45,19.45,0,1,0-.94-15.67l12.16,9.89L117,690.1A19.4,19.4,0,0,0,119.18,699Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M128.79,661.19a19.46,19.46,0,0,0,20.35-18.53,19.24,19.24,0,0,0-1.68-8.87A19.49,19.49,0,0,0,135,623l.11,8-4.41-8.72h0a19.46,19.46,0,1,0-1.82,38.88Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M81.55,629.76a19.47,19.47,0,1,0,1.82-38.89A19.28,19.28,0,0,0,73,593.34l3.44,9.42L69.31,596A19.4,19.4,0,0,0,63,609.4a19,19,0,0,0,.5,5.36A19.47,19.47,0,0,0,81.55,629.76Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M87.1,572.45c4.49.49,8.85,1.89,13.36,2.17s9.46-.8,12.31-4.31c1.54-1.88,2.3-4.27,3.6-6.33a13.79,13.79,0,0,1,4.9-4.61,19.46,19.46,0,1,1-36.38,12.91C85.63,572.32,86.36,572.37,87.1,572.45Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M81.55,629.76A19.48,19.48,0,0,0,100.06,602a14.58,14.58,0,0,0-3.91,3.92c-1.39,2.09-2.23,4.51-3.86,6.43-3,3.57-8.21,4.73-12.9,4.52s-9.23-1.55-13.91-2c-.65-.06-1.31-.1-2-.12A19.47,19.47,0,0,0,81.55,629.76Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M128.79,661.19a19.46,19.46,0,0,0,20.35-18.53,19.24,19.24,0,0,0-1.68-8.87,15.66,15.66,0,0,0-4.11,4c-1.51,2.13-2.46,4.59-4.23,6.56-3.28,3.65-8.8,4.94-13.77,4.82-4.82-.1-9.46-1.28-14.25-1.65A19.47,19.47,0,0,0,128.79,661.19Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M119.18,699a19.46,19.46,0,0,0,35.48-15.88,19.6,19.6,0,0,0-4.27,3.81c-1.85,2.26-3.07,4.82-5.21,6.92-4,3.9-10.4,5.51-16.12,5.66A82.85,82.85,0,0,1,119.18,699Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M702,642.75a15.53,15.53,0,0,0-6.18-12.52c-.24-9.17-6.78-16.66-15.19-17.82a18.13,18.13,0,0,0-12.08-13.52h0a15.34,15.34,0,0,0-2.25-.53l-.22,0-.39-.05-.33,0-.33,0-.43,0-.26,0h-.71c-8.58,0-15.72,6.56-17.19,15.21-5.55-1.28-10.64.38-11.55,3.89a4.75,4.75,0,0,0,.15,2.81c.94,2.72,4,5.32,8.15,6.61l.54.16c.27.08.54.14.81.2l.18,0h0a14,14,0,0,0,6.11,18.31,3.17,3.17,0,0,0-.36.23,5,5,0,0,0-1.2,1.68,24.36,24.36,0,0,0-2.32,5.59c-.4,1.67-.47,3.42-1,5.07-.91,3-3.25,5.63-3.52,8.82-.12,1.42.11,3.09-.9,4.06a6.6,6.6,0,0,1-.8.59,6.18,6.18,0,0,0-1.76,1.84A5.88,5.88,0,0,1,637.8,675c-.91.69-2.41.62-2.86,1.68s.71,2.31.44,3.47c-.22.94-1.25,1.37-2,2a7.09,7.09,0,0,0-1.7,3.23,10.34,10.34,0,0,1-8.53-2.17,16,16,0,0,1,.88,3.19c-1.19-1.27-3.15-1.64-4.6-2.3a14.69,14.69,0,0,1-4.9-3.64l2.62-.36L605.55,662.5l-3.42-.7,3.07,5.89a1.84,1.84,0,0,0-1,1.26,5.36,5.36,0,0,0-.12,2,37,37,0,0,0,.79,4.69l.89,4.14a10.74,10.74,0,0,0,.29,1.15,11.66,11.66,0,0,0-3.44.39,30.22,30.22,0,0,0-7.13-1.69,3.64,3.64,0,0,0-1.61.08,3.9,3.9,0,0,0-1.5,1.22,48,48,0,0,0-5.3,7.46c-6.23,10.84-14.55,20.3-22.34,30.1-5.38,2.19-10.8,4.27-16.23,6.33l-11.67,4.45c-2.33.89-4.75,1.8-7.23,1.64-1.12-.07-2.48-.24-3.11.71a6,6,0,0,0-.71,1.52c-.41,0-.82.1-1.2.12h-.07c-.74-1.84-1.38-3.81-2.8-5.15a1.74,1.74,0,0,0-1.32,1c-.28.52-.45,1.09-.77,1.57-.63.92-1.72,1.37-2.5,2.15s-1.27,2-2.11,2.76a8.38,8.38,0,0,1-4,1.55,25.25,25.25,0,0,0-6.21,2.36,10.63,10.63,0,0,1-2.3,1.06,8.66,8.66,0,0,1-2.69.09l-6.18-.45a4.81,4.81,0,0,0-1.65.07,3.07,3.07,0,0,0-2,3.17,4.93,4.93,0,0,0,1.95,3.4,13,13,0,0,0,3.52,1.83A102.22,102.22,0,0,0,512,753.52v1.25a28.07,28.07,0,0,0,12.61,3,1.88,1.88,0,0,0,.94-.17,2.09,2.09,0,0,0,.79-1.24,51,51,0,0,0,2.47-12.11h0a6.23,6.23,0,0,0,2.23-.57c2.13-.58,4.24.88,6.43,1.12,2.7.29,5.21-1.28,7.76-2.25.37-.14.74-.26,1.11-.38a12.43,12.43,0,0,1-2.55,2.47c-1.06.76-2.25,1.32-3.29,2.11a21.87,21.87,0,0,1-2.77,2.15,16.7,16.7,0,0,1-2.13.82,14.44,14.44,0,0,0-3,1.51,6.24,6.24,0,0,0-2.08,2,2.73,2.73,0,0,0,1.86,4.26,8.58,8.58,0,0,0,2.53.07c3.34-.25,6.67-.56,10-.86a28,28,0,0,0,4.19-.6c.73-.18,1.45-.42,2.18-.61a17.64,17.64,0,0,1,3.81-.57,3.16,3.16,0,0,1,1.11.11c.78.25,1.33,1,2.12,1.2a3.27,3.27,0,0,0,1.51-.21,34.69,34.69,0,0,1,7.42-.79c1.09-.06,2.37-.27,2.88-1.28.62-1.25-.42-2.65-.83-4a12.06,12.06,0,0,1-.34-2.62,16.34,16.34,0,0,0-1.84-6.23,16.87,16.87,0,0,1-1.37-2.84,72.27,72.27,0,0,0,13.64-6.92c2.46-1.53,5-3.18,7.78-3.74,3.24-.65,6.58.21,9.77,1.13a219.71,219.71,0,0,1,22.39,7.81c3.5,1.43,7,2.95,10.58,4a16.47,16.47,0,0,0,3.75,3.66c2.4,1.55,5.33,2,8.15,2.22a107,107,0,0,0,11.46.43c2.92-.05,5.93-.25,8.54-1.58a9.89,9.89,0,0,0,1.79-1.18c2,.36,4.05-.71,5.62-2.08a13.6,13.6,0,0,0,4.3-6.75c.92-3.61.21-7.82,2.43-10.77.59-.79,1.36-1.43,1.94-2.23a6,6,0,0,0,1-3.63l.1-.15a13.48,13.48,0,0,0,1-3.64,20.83,20.83,0,0,1,1-2.87,86.68,86.68,0,0,0,2.94-8.53,46.82,46.82,0,0,0,1.36-5.85c.24-1.58.38-3.17.51-4.76a28.71,28.71,0,0,1,1.44-7.31,59.72,59.72,0,0,0,3.31-17.52c0-.12,0-.23,0-.35A11.73,11.73,0,0,0,701,655.81a12.54,12.54,0,0,0-1.08-5.11A15.86,15.86,0,0,0,702,642.75Zm-56.55,68.71c.17.61.37,1.22.57,1.83-.92-.91-1.83-1.85-2.76-2.75.37.11.74.23,1.1.36A6.6,6.6,0,0,1,645.46,711.46Zm-4.48-3c-5.46-4.74-11.78-8.42-17.37-13,3,1.51,6,3.26,9,4.94q5.24,3,10.6,5.74A8.62,8.62,0,0,1,641,708.42Zm2.33-11.94.26-.27c0,.67,0,1.3,0,1.87-.49-.16-1-.32-1.47-.5A12.4,12.4,0,0,0,643.31,696.48Zm-48.07,12.84a45.32,45.32,0,0,0,5.83-8.31c2.16,3.79,5.68,6.52,8.68,9.69C604.92,710.06,600.09,709.53,595.24,709.32Z",
  transform: "translate(-28.5 -118.14)",
  fill: "url(#fb6415c1-f574-4dab-bb02-7ceb0a7d0718)"
});

var _ref45 = /*#__PURE__*/React.createElement("polygon", {
  points: "574.53 545.12 577.98 545.82 589.73 563.18 584.54 563.88 574.53 545.12",
  fill: "#2f2e41"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M519.48,733.72a68.35,68.35,0,0,0,3.43,9,83.16,83.16,0,0,0,11.46-3.27,31.22,31.22,0,0,0-2.38-3.23,11.23,11.23,0,0,0-3.24-2.49c-1.19-.52-2.66-.13-3.93-.06Q522.15,733.77,519.48,733.72Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#fbbebe"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M528.77,738.36c-1.94-.61-3.13-2.57-3.92-4.46s-1.43-3.95-2.93-5.34a1.75,1.75,0,0,0-1.32,1c-.29.5-.46,1.07-.79,1.55-.62.9-1.72,1.34-2.51,2.11s-1.28,1.94-2.13,2.71a8.47,8.47,0,0,1-4,1.54,25.35,25.35,0,0,0-6.26,2.32,10.7,10.7,0,0,1-2.32,1,8.79,8.79,0,0,1-2.71.09l-6.23-.45a4.86,4.86,0,0,0-1.66.08,3,3,0,0,0-2,3.12,4.84,4.84,0,0,0,2,3.35,13.28,13.28,0,0,0,3.54,1.8,106.73,106.73,0,0,0,16.7,4.77v1.23a28.91,28.91,0,0,0,12.71,3,2,2,0,0,0,1-.17,2.08,2.08,0,0,0,.8-1.22,49.18,49.18,0,0,0,2.59-13.54,10.16,10.16,0,0,0-.26-3.48c-.34-1.12.82-.65-.26-1.09",
  transform: "translate(-28.5 -118.14)",
  fill: "#2f2e41"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M648.21,714.88C629.74,716,611.5,710.58,593,710a27.61,27.61,0,0,0-6.86.44,33.71,33.71,0,0,0-6.8,2.64c-9.91,4.61-20.17,8.43-30.42,12.25l-11.76,4.38c-2.36.87-4.79,1.76-7.3,1.61-1.12-.07-2.49-.24-3.13.7-1.91,2.83-1,7,.26,10.18.41,1,1.1,2.15,2.2,2.27a6.49,6.49,0,0,0,2.25-.57c2.14-.57,4.28.87,6.48,1.1,2.73.29,5.26-1.26,7.83-2.21,4.26-1.57,8.92-1.52,13.4-2.27,7.52-1.25,14.48-4.74,21-8.72,2.48-1.51,5-3.13,7.84-3.68,3.27-.64,6.64.2,9.85,1.11a227.16,227.16,0,0,1,22.57,7.69,104,104,0,0,0,11.8,4.3,42.66,42.66,0,0,0,26.44-1.54c3-1.17,6.16-3.23,6.33-6.42.1-1.82-1.31-3.42-2.25-5-.61-1-1.21-2-1.87-2.95C657.68,720.67,653.82,714.54,648.21,714.88Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#2f2e41"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M648.21,714.88C629.74,716,611.5,710.58,593,710a27.61,27.61,0,0,0-6.86.44,33.71,33.71,0,0,0-6.8,2.64c-9.91,4.61-20.17,8.43-30.42,12.25l-11.76,4.38c-2.36.87-4.79,1.76-7.3,1.61-1.12-.07-2.49-.24-3.13.7-1.91,2.83-1,7,.26,10.18.41,1,1.1,2.15,2.2,2.27a6.49,6.49,0,0,0,2.25-.57c2.14-.57,4.28.87,6.48,1.1,2.73.29,5.26-1.26,7.83-2.21,4.26-1.57,8.92-1.52,13.4-2.27,7.52-1.25,14.48-4.74,21-8.72,2.48-1.51,5-3.13,7.84-3.68,3.27-.64,6.64.2,9.85,1.11a227.16,227.16,0,0,1,22.57,7.69,104,104,0,0,0,11.8,4.3,42.66,42.66,0,0,0,26.44-1.54c3-1.17,6.16-3.23,6.33-6.42.1-1.82-1.31-3.42-2.25-5-.61-1-1.21-2-1.87-2.95C657.68,720.67,653.82,714.54,648.21,714.88Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M554.93,734.62q4.34,1.47,8.74,2.72c1.65-2.71,4.73-4.59,5.43-7.68a.72.72,0,0,0,0-.41.74.74,0,0,0-.33-.3,16.35,16.35,0,0,0-6.85-2c-1.9-.12-2.76,1.86-3.62,3.25C558,730.76,555.7,734.88,554.93,734.62Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#fbbebe"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M559,732.64a6.29,6.29,0,0,1-4.25-2.79c-.41-.71-.84-1.67-1.66-1.62s-1.1.95-1.27,1.7a48.57,48.57,0,0,1-2.39,8.21,15.39,15.39,0,0,1-5.11,6.71c-1.07.74-2.26,1.3-3.31,2.08a21.91,21.91,0,0,1-2.8,2.12,15.8,15.8,0,0,1-2.15.8,14.76,14.76,0,0,0-3.07,1.49,6.25,6.25,0,0,0-2.09,2,3,3,0,0,0-.18,2.8,3,3,0,0,0,2,1.41,9.07,9.07,0,0,0,2.55.06c3.37-.25,6.73-.55,10.09-.85a28.68,28.68,0,0,0,4.23-.58c.74-.18,1.46-.42,2.19-.61a18.54,18.54,0,0,1,3.85-.56,3.26,3.26,0,0,1,1.12.11c.78.25,1.33,1,2.13,1.18a3.3,3.3,0,0,0,1.52-.2,36,36,0,0,1,7.48-.78c1.1-.06,2.4-.27,2.9-1.26.63-1.23-.41-2.61-.83-3.93a12.33,12.33,0,0,1-.35-2.58,15.71,15.71,0,0,0-1.85-6.13c-.86-1.58-2-3.32-1.43-5a4.38,4.38,0,0,0,.57-1.71C566.75,732,560.52,733,559,732.64Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#2f2e41"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M620.52,685.26a14.48,14.48,0,0,1-7.36-7.31c-.3-.7-.56-1.43-.85-2.14a16.37,16.37,0,0,0-4.4-6.1,2.11,2.11,0,0,0-1.63-.69,1.74,1.74,0,0,0-1.2,1.28,5.25,5.25,0,0,0-.13,2,37.64,37.64,0,0,0,.8,4.61l.9,4.08a8,8,0,0,0,.56,1.82,6.34,6.34,0,0,0,1.5,1.79c.82.76,1.65,1.49,2.49,2.2a8.82,8.82,0,0,0,1.51,1.1,9.26,9.26,0,0,0,2.81.82c3.67.68,7.4,1.66,10.49,4,0,0,0-2.73-.07-3a4,4,0,0,0-.78-2.19C624,686.28,622,685.91,620.52,685.26Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#fbbebe"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M620.52,685.26a14.48,14.48,0,0,1-7.36-7.31c-.3-.7-.56-1.43-.85-2.14a16.37,16.37,0,0,0-4.4-6.1,2.11,2.11,0,0,0-1.63-.69,1.74,1.74,0,0,0-1.2,1.28,5.25,5.25,0,0,0-.13,2,37.64,37.64,0,0,0,.8,4.61l.9,4.08a8,8,0,0,0,.56,1.82,6.34,6.34,0,0,0,1.5,1.79c.82.76,1.65,1.49,2.49,2.2a8.82,8.82,0,0,0,1.51,1.1,9.26,9.26,0,0,0,2.81.82c3.67.68,7.4,1.66,10.49,4,0,0,0-2.73-.07-3a4,4,0,0,0-.78-2.19C624,686.28,622,685.91,620.52,685.26Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref54 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 629.62,
  cy: 531.4,
  rx: 4.49,
  ry: 4.52,
  fill: "#2f2e41"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M655.34,646.81a5,5,0,0,0-3.55.51,4.78,4.78,0,0,0-1.21,1.66,23.59,23.59,0,0,0-2.34,5.5c-.4,1.65-.47,3.37-1,5-.92,3-3.28,5.55-3.55,8.68-.12,1.4.11,3.05-.91,4a5.88,5.88,0,0,1-.81.57,6.14,6.14,0,0,0-1.77,1.82,5.77,5.77,0,0,1-1.25,1.73c-.92.68-2.43.61-2.88,1.66s.71,2.27.44,3.41c-.22.93-1.26,1.36-2,2a6.92,6.92,0,0,0-1.71,3.19,10.59,10.59,0,0,1-8.59-2.15c1.25,3.09,1.28,6.5,1.33,9.83a4.06,4.06,0,0,1-.79,3c3.58.08,7.06,1,10.55,1.83a7.24,7.24,0,0,0,4.6,0,7.6,7.6,0,0,0,2.11-1.68c1.9-1.93,3.89-4,4.35-6.69a36.34,36.34,0,0,0,.08-4.55,26.1,26.1,0,0,1,1.15-5.51,64.45,64.45,0,0,0,2-11.35c.21-2.37,2.25-4.27,3.33-6.39,2-4,4.1-8.15,4.26-12.63C657.32,648.79,656.82,647,655.34,646.81Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#2f2e41"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M655.34,646.81a5,5,0,0,0-3.55.51,4.78,4.78,0,0,0-1.21,1.66,23.59,23.59,0,0,0-2.34,5.5c-.4,1.65-.47,3.37-1,5-.92,3-3.28,5.55-3.55,8.68-.12,1.4.11,3.05-.91,4a5.88,5.88,0,0,1-.81.57,6.14,6.14,0,0,0-1.77,1.82,5.77,5.77,0,0,1-1.25,1.73c-.92.68-2.43.61-2.88,1.66s.71,2.27.44,3.41c-.22.93-1.26,1.36-2,2a6.92,6.92,0,0,0-1.71,3.19,10.59,10.59,0,0,1-8.59-2.15c1.25,3.09,1.28,6.5,1.33,9.83a4.06,4.06,0,0,1-.79,3c3.58.08,7.06,1,10.55,1.83a7.24,7.24,0,0,0,4.6,0,7.6,7.6,0,0,0,2.11-1.68c1.9-1.93,3.89-4,4.35-6.69a36.34,36.34,0,0,0,.08-4.55,26.1,26.1,0,0,1,1.15-5.51,64.45,64.45,0,0,0,2-11.35c.21-2.37,2.25-4.27,3.33-6.39,2-4,4.1-8.15,4.26-12.63C657.32,648.79,656.82,647,655.34,646.81Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M651.14,718.77c-3.85-1.83-6.66-5.24-9.77-8.16-5.94-5.58-13.2-9.52-19.44-14.75-4.13-3.46-7.83-7.49-12.38-10.39a30.74,30.74,0,0,0-13.26-4.65,3.68,3.68,0,0,0-1.62.08,3.89,3.89,0,0,0-1.51,1.2,47.12,47.12,0,0,0-5.35,7.35c-7.91,13.42-19.14,24.71-28.45,37.2a1.67,1.67,0,0,0-.11,2.26l1.89,3.71c1.06,2.07,2.76,4.49,5,4.08a5.55,5.55,0,0,0,2.65-1.69l8.5-8.13,8.91-8.52c5.22-5,10.53-10.1,13.94-16.48,2.66,4.61,7.38,7.63,10.62,11.86,1.23,1.6,2.23,3.37,3.33,5.07,1.77,2.73,3.77,5.29,5.77,7.84l10.23,13.05a19.79,19.79,0,0,0,4.73,4.8c2.42,1.53,5.37,1.94,8.22,2.19a105.89,105.89,0,0,0,11.55.42c2.94-.05,6-.24,8.6-1.55s4.81-4,4.67-6.93a10.29,10.29,0,0,0-1.47-4.33C662.78,727.6,658,722,651.14,718.77Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#2f2e41"
});

var _ref58 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 632.38,
  cy: 534.53,
  rx: 3.45,
  ry: 3.47,
  fill: "#e8e8f0"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M660.12,650.06a6.6,6.6,0,0,1,.38,5,19.33,19.33,0,0,1-2.22,4.6,22.92,22.92,0,0,1-2.89,4.12c5.33.26,10.5-1.83,15.2-4.37,3.79-2,7.57-4.55,9.59-8.36a4.44,4.44,0,0,1-3.53-.65,13.22,13.22,0,0,1-2.71-2.52l-2.67-3a12,12,0,0,1-1.65-2.17,6,6,0,0,1-.71-3.49,20,20,0,0,1-3.54,2.94c-1.91,1.25-4,2.15-5.93,3.38-.68.44-2.19,1.15-1.8,2S659.58,649.1,660.12,650.06Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#fbbebe"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M660.12,650.06a6.6,6.6,0,0,1,.38,5,19.33,19.33,0,0,1-2.22,4.6,22.92,22.92,0,0,1-2.89,4.12c5.33.26,10.5-1.83,15.2-4.37,3.79-2,7.57-4.55,9.59-8.36a4.44,4.44,0,0,1-3.53-.65,13.22,13.22,0,0,1-2.71-2.52l-2.67-3a12,12,0,0,1-1.65-2.17,6,6,0,0,1-.71-3.49,20,20,0,0,1-3.54,2.94c-1.91,1.25-4,2.15-5.93,3.38-.68.44-2.19,1.15-1.8,2S659.58,649.1,660.12,650.06Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M660.19,650.58a4.51,4.51,0,0,0,0,5.21c.15.19.72,1.38,1,1.39a.91.91,0,0,0,.61-.31,42.39,42.39,0,0,0,3.38-4,7.46,7.46,0,0,1,4.3-2.82c2.09-.33,4.1.78,5.93,1.84a5.66,5.66,0,0,1,2,1.66,5.45,5.45,0,0,1,.67,2.26,105.81,105.81,0,0,1,.6,14.36A55.24,55.24,0,0,1,678,680.5c-.34,1.76-.85,3.48-1.09,5.26a35.36,35.36,0,0,0-.21,4.72v6.6a16.75,16.75,0,0,0,.26,3.61,44.11,44.11,0,0,0,1.45,4.19,27.61,27.61,0,0,1,1,5l.9,6.83c.29,2.16.5,4.51-.81,6.24-.58.79-1.36,1.41-2,2.19C675.25,728,676,732.15,675,735.7a13.37,13.37,0,0,1-4.34,6.65c-1.59,1.35-3.65,2.42-5.71,2-2.77-.52-4.44-3.41-5.2-6.14s-1-5.71-2.67-8c-1.34-1.89-3.41-3.07-5.28-4.42s-3.71-3.08-4.12-5.36c-.18-1-.07-2-.17-3a7.15,7.15,0,0,0-4.42-5.8c-1.42-.55-3.18-.75-4-2a9.63,9.63,0,0,0,4.16-5.59,28.7,28.7,0,0,0,1-7l.48-7.94c.21-3.55.31-7.07,1.87-10.26.7-1.42,1.57-2.76,2.29-4.17a46.27,46.27,0,0,0,2.46-6.12c1.13-3.25,2.27-6.51,3.28-9.8a19.42,19.42,0,0,1,1.8-4.57C657.36,652.68,658.59,650.88,660.19,650.58Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#e8e8f0"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M642.56,702.17l2.1.07.45-3.17a6.84,6.84,0,0,1,.44-1.85,11.78,11.78,0,0,1,1.21-1.77c2.07-2.92,1.92-6.8,2.43-10.35.68-4.73,2.66-9.17,4.62-13.53l4.08-9.09a13.08,13.08,0,0,0,.87-2.33,12.77,12.77,0,0,0,.25-2.69c0-1.4.46-6.51.49-7.92,0-.52-1.14-.23-1.38-.69-.51-1-1.21,1.72-2.17,2.32a5.32,5.32,0,0,0-1.88,2.75c-.88,2.29-1.42,4.7-2.24,7a14.39,14.39,0,0,1-3.81,6.19c-.83.74-1.8,1.32-2.59,2.1-2.54,2.51-2.78,6.47-2.87,10C642.5,681.4,642.09,702.17,642.56,702.17Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#2f2e41"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M672.81,646.79c-2,.8-3.16,3-3.73,5.14s-.81,4.4-1.91,6.3c-2.56,4.46-9.09,5.76-10.9,10.58a19.35,19.35,0,0,0-.73,5c-.32,3.45-1.46,6.79-1.8,10.24a45.15,45.15,0,0,0,.19,8.05l2.29,27.23a36,36,0,0,1-.69,12,11.53,11.53,0,0,0,6.86-1.13c2.15-1,4.11-2.32,6.17-3.46,3.55-2,7.47-3.35,10.57-6a6.27,6.27,0,0,0,1.43-1.57,13.51,13.51,0,0,0,1-3.59,20.19,20.19,0,0,1,1-2.82,83.75,83.75,0,0,0,3-8.4,45.24,45.24,0,0,0,1.37-5.77c.25-1.55.38-3.12.52-4.68a27.57,27.57,0,0,1,1.45-7.2,57.73,57.73,0,0,0,3.33-17.25,8.64,8.64,0,0,0-.17-2.54,13.61,13.61,0,0,0-1.38-2.88c-.95-1.79-1.52-3.76-2.42-5.57-2-4.1-5.59-7.21-9.34-9.82C677,647.38,674.89,646,672.81,646.79Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#2f2e41"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M625.07,691.22a16.4,16.4,0,0,1-4.35-3.3c-.57-.67-1-1.42-1.62-2.08a10.69,10.69,0,0,0-5.47-3.12,26.39,26.39,0,0,0-6.34-.61,11.26,11.26,0,0,0-4.21.51,4.25,4.25,0,0,0-2.8,3c-.31,1.7.8,3.35,2.13,4.43a10.29,10.29,0,0,0,4.25,2.07,35.27,35.27,0,0,0,3.84.45c7.56.79,14.31,4.9,20.93,8.65q8.73,4.93,17.8,9.23a35.63,35.63,0,0,0,.3-5.46c0-1.36-.1-3.44-1.39-4.24-1.5-.94-4-1.15-5.66-1.71a89.79,89.79,0,0,1-11.39-4.6C629,693.43,627,692.36,625.07,691.22Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#fbbebe"
});

var _ref65 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 629.62,
  cy: 516.82,
  rx: 13.47,
  ry: 13.55,
  fill: "#fbbebe"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M676.66,662.15a21.9,21.9,0,0,0-2.61,4.87c-1.67,3.43-4.28,6.37-5.58,10-1.38,3.77-1.33,8.26-4,11.23a3.87,3.87,0,0,0-1.17,1.7,8.42,8.42,0,0,1-.14,1.23c-.38,1.08-2.15,1.13-2.48,2.23-.09.32,0,.67-.16,1-.27.71-1.2.81-1.83,1.24-1.31.89-1,2.95-2,4.23a3.55,3.55,0,0,1-3.36,1.18,12.46,12.46,0,0,1-3.5-1.31,3.14,3.14,0,0,0-1.25-.39,2.55,2.55,0,0,0-1.45.49c-2.49,1.58-3.66,4.72-3.64,7.68a25,25,0,0,0,2.07,8.58,3.61,3.61,0,0,0,.69,1.28c.82.87,2.26.73,3.36.24a15.65,15.65,0,0,1,3.27-1.46c2.08-.38,4.12,1.06,6.23.94a8.78,8.78,0,0,0,4.21-1.86A23.3,23.3,0,0,0,669,710.4c.92-1.21,1.6-2.59,2.41-3.88a44,44,0,0,1,3.4-4.54l7.77-9.51a20.42,20.42,0,0,0,2.09-2.89,21.17,21.17,0,0,0,1.63-4.34,34.31,34.31,0,0,0,1.61-7.73,30.84,30.84,0,0,0-.57-6.49,22.55,22.55,0,0,0-1.67-6.17C683.94,661.35,679.83,658.45,676.66,662.15Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#2f2e41"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M703.72,644.5a15.17,15.17,0,0,0-6.24-12.33,18,18,0,0,0-15.31-17.55,17.5,17.5,0,0,0-34.47.93c-5.6-1.26-10.72.38-11.65,3.83-1,3.61,3,7.83,8.92,9.43a16.39,16.39,0,0,0,5.71.57,17.55,17.55,0,0,0,12.06,7.5,17.93,17.93,0,0,0,13.15,13.57,15,15,0,0,0,4.06,5.62c0,.42-.07.85-.07,1.29a11.41,11.41,0,1,0,22.8,0,12,12,0,0,0-1.09-5A15.33,15.33,0,0,0,703.72,644.5Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#f86d70"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M639.85,620.07c.93-3.45,6-5.09,11.65-3.83a17.79,17.79,0,0,1,17.33-15c.39,0,.78,0,1.16,0a17,17,0,0,0-5-.74,17.79,17.79,0,0,0-17.33,15c-5.6-1.26-10.72.38-11.65,3.83-1,3.61,3,7.83,8.92,9.43a17.13,17.13,0,0,0,3.37.58C642.68,627.7,638.9,623.6,639.85,620.07Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M683.68,658.06c0-.44,0-.87.07-1.3a14.94,14.94,0,0,1-4.06-5.61,18,18,0,0,1-13.15-13.58,17.52,17.52,0,0,1-12.06-7.5,15.93,15.93,0,0,1-3.36-.09,17.49,17.49,0,0,0,11.62,6.9,17.93,17.93,0,0,0,13.15,13.57,15,15,0,0,0,4.06,5.62c0,.42-.07.85-.07,1.29a11.61,11.61,0,0,0,11.34,11.8A11.78,11.78,0,0,1,683.68,658.06Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var _ref70 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 662.61,
  cy: 637.73,
  rx: 2.08,
  ry: 2.77,
  transform: "translate(-279.29 412.54) rotate(-37.22)",
  fill: "#fbbebe"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M342.3,707.35l13.32-7.83a32,32,0,0,0-6.81-8.15l-25.12,7.81,19.68-11.57A32,32,0,0,0,296,715.68c0,17.67,14.33,18.28,32,18.28s32-.61,32-18.28a31.75,31.75,0,0,0-2.75-13Z",
  transform: "translate(-28.5 -118.14)",
  fill: "#6368ff"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M345.69,724.53a25,25,0,0,0-4.72-3.71c-2.41-1.61-4.92-3.25-7.77-3.79-2.5-.48-5.08-.07-7.63-.22a17.83,17.83,0,0,1-11.69-5.36c-1.82-1.88-3.25-4.19-5.44-5.63a11.9,11.9,0,0,0-8.14-1.49,19.79,19.79,0,0,0-2.41.49A32,32,0,0,0,296,715.68c0,17.67,14.33,18.28,32,18.28,8.58,0,16.36-.14,22.11-2.31l-1-1.79A24.88,24.88,0,0,0,345.69,724.53Z",
  transform: "translate(-28.5 -118.14)",
  opacity: 0.1
});

var SvgImageTableChanges = function SvgImageTableChanges(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bf2b12fd-98ef-4df9-abe4-52340225686d",
    "data-name": "Layer 1",
    width: 1143,
    height: 663.73,
    viewBox: "0 0 1143 663.73",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageTableChanges, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/imageTableChanges.26fdd3d2.svg";
export { ForwardRef as ReactComponent };